import React from 'react';
import styles from '../../command-palette.scss';
import PropTypes from 'prop-types';

const DoubleGhostItem = () => (
  <div className={styles.commandPaletteGhostItem}>
    <div className={styles.ghostItemUpper} />
    <div className={styles.ghostItemLower} />
  </div>
);

const SingleGhostItem = () => (
  <div className={styles.commandPaletteGhostItem}>
    <div className={styles.ghostItemUpper} />
  </div>
);

export const CommandPaletteGhostItems = ({ count = 6, type = 'double' }) => {
  return (
    <div className={styles.commandPaletteGhostItems}>
      {Array.from({ length: count }).map((_, index) =>
        type === 'double' ? (
          <DoubleGhostItem key={index} />
        ) : (
          <SingleGhostItem key={index} />
        ),
      )}
    </div>
  );
};

CommandPaletteGhostItems.propTypes = {
  count: PropTypes.number,
  type: PropTypes.string,
};
